import React from "react";
import { BasePage } from "@components/Base/BasePage";
import { withRouter } from "react-router-dom";
import styles from "./index.module.scss";
class PrivacyPCPage extends BasePage<any,any> {
    componentDidMount() {
        super.componentDidMount();
    }

    render() {
        return (
            <div className={styles.box}>
                <h1 className={styles.title}>vivo社区隐私政策</h1>
                <p className={styles.centerTime}>生效时间：2026年1月22日</p>
                <p className={styles.centerTime}>更新时间：2026年1月22日</p>
                
                <p className={styles.intro}>尊敬的用户：</p>
                <p className={styles.p}>本隐私政策适用于广东天宸网络科技有限公司及其关联公司（以下简称"vivo"或"我们"）提供的vivo社区产品及服务（以下统称"本服务"）。vivo社区应用程序包含APP、web版本。<span className={styles.p}>我们十分尊重您的个人信息和数据，并会尽全力保护您的个人信息和数据。<span className={styles.bold}>请您务必认真阅读《vivo社区隐私政策》（特别是以黑体或下划线的形式标注的内容）并确定了解我们对您个人信息的处理规则，请您在确认充分了解并同意后使用我们的产品及服务。如果您/您的监护人不同意本隐私政策的任何内容，您应该立即停止使用本服务，当您开始使用，即表示您/您的监护人已经同意我们按照本政策来收集、保存、使用、共享、保护您的个人信息。</span></span></p>
                
                <p className={styles.p}>本政策主要包括内容如下：</p>
                <ol className={styles.ol}>
                    <li className={styles.li}>1.本服务各项服务或功能收集的个人信息范围、收集目的、收集方式，我们严格按照法律法规收集使用您的个人信息，如您拒绝提供部分信息，可能会影响您使用部分服务。</li>
                    <li className={styles.li}>2.本政策可能会有更新，我们会按本政策标明的方式告知您。如果我们的个人信息收集使用超出了本政策说明的范围，我们会再次向您告知并征得您的同意。</li>
                    <li className={styles.li}>3.有关个人信息权利的实现方式、转让与公开披露、保护个人信息安全采取的措施等本政策正文未列举的内容，我们会参照《vivo隐私政策》（详见：<a href="https://www.vivo.com/cn/about-vivo/privacy-policy" target="_blank" rel="noopener noreferrer" className={styles.a}>https://www.vivo.com/cn/about-vivo/privacy-policy</a>）中的内容来实现，请您注意查阅相关内容。</li>
                </ol>
                <p className={styles.p}>本政策将帮您了解以下内容：</p>
                <ul className={styles.ul}>
                    <li className={styles.li}>一、我们为什么要收集您的个人信息</li>
                    <li className={styles.li}>二、我们将如何收集和使用您的个人信息</li>
                    <li className={styles.li}>三、我们如何共享您的个人信息</li>
                    <li className={styles.li}>四、我们如何处理未成年人的个人信息</li>
                    <li className={styles.li}>五、我们如何保存您的个人信息</li>
                    <li className={styles.li}>六、个人信息管理</li>
                    <li className={styles.li}>七、本政策如何更新</li>
                    <li className={styles.li}>八、如何联系我们</li>
                    <li className={styles.li}>九、保留说明</li>
                </ul>

                <h2 className={styles.h2}>一、我们为什么要收集您的个人信息</h2>
                <p className={styles.p}>为了向您提供vivo社区服务、了解及分析产品故障、不断优化提升产品能力，以便为您带来更好的用户体验，我们可能会依据您的同意或提供服务的必要性而收集您的个人信息。</p>
                <p className={styles.p}>同时，我们还可能会根据国家法律法规或政府主管部门的要求，收集您的信息和数据。</p>
                <p className={styles.p}>具体而言，我们会基于以下合法性基础中的一种或多种处理您的个人信息：</p>
                <ol className={styles.ol}>
                    <li className={styles.li}>（1）您的同意；</li>
                    <li className={styles.li}>（2）订立、履行与您之间的合同；</li>
                    <li className={styles.li}>（3）履行法定职责或者法定义务；</li>
                    <li className={styles.li}>（4）应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</li>
                    <li className={styles.li}>（5）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</li>
                    <li className={styles.li}>（6）在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；</li>
                    <li className={styles.li}>法律、行政法规规定的其他情形。</li>
                </ol>

                <h2 className={styles.h2}>二、我们将如何收集和使用您的个人信息</h2>

                <p className={styles.p}>2.1 账号注册。为了完成本服务的账号注册，便于您后续使用本服务，我们收集您输入的vivo账号信息（如您使用手机号码、邮箱注册或者其他账号信息）、设备标识符和网络信息。详见《vivo账号隐私政策》（<a href="https://usrsys-pro.vivo.com.cn/pro/privacy/policy/privacy_zh_CN.html" target="_blank" rel="noopener noreferrer" className={styles.a}>https://usrsys-pro.vivo.com.cn/pro/privacy/policy/privacy_zh_CN.html</a>）</p>

                <p className={styles.p}>2.2 账号登录。在vivo社区，你可以通过登录vivo账号使用本服务，我们将获取您的vivo账号信息（包括openid、手机号）、社区头像、昵称。</p>

                <p className={styles.p}>2.3 编辑个人信息。为展示您的个性化信息，您可以在APP端编辑您的个人信息（如头像、昵称、性别、个人简介、出生日期、年龄、背景图），您也可以编辑姓名、手机号、收货地址用于实物奖品兑换时寄送奖品，此时我们将获取您以上的个人信息。该信息由您主动填写，且会上传至服务器。</p>

                <p className={styles.p}>2.4 问题解决与服务建议。您可以通过我们公布的联系方式或线上渠道，向我们反馈您遇到的问题或服务建议。为了分析解决异常问题，我们会收集您反馈的问题信息、问题日志信息、vivo账号信息，硬件型号、系统版本号、IMEI、VAID、手机号、以及您上传的文字、图片、视频、联系方式、填写的设备标识信息等， 收集此类信息的目的是为了对所收集的数据进行分析，以及改进应用和服务。我们可能会根据您提供的联系方式对您进行电话回访，以便解决您在使用本服务过程中遇到的问题。</p>

                <p className={styles.p}>2.5 参与官方活动。当您在参加由社区举办的官方活动时，我们可能会收集您的姓名、身份证号、出生日期、手机号、城市、年龄、性别、职业、所在地区等个人信息，用于您参与社区线上或线下活动的报名。该信息由您主动填写，且会上传至服务器。</p>
                <p className={styles.p}>当您在参加社区的拉新活动时，我们可能需要访问您的剪切板，读取其中包含的推荐人被推荐人信息，以实现其功能或服务。该信息仅在本地处理，不上传至服务器。</p>

                <p className={styles.p}>2.6 发放奖品。在向活动中的获奖用户发放实体奖品前，我们会收集您的姓名、手机号、收货地址。收集上述信息的目的用于满足发放实体奖品的报税要求，并确保奖品可以安全、准确地送达。该信息由您主动填写，且会上传至服务器。</p>
                <p className={styles.p}>其中，在您提交身份证号信息时，若检测到您是未满14周岁的儿童，您在使用社区提供的服务时，需要经过您的监护人的同意。为此，我们需要收集您的监护人的联系电话及短信验证码，以用于验证授权结果。</p>

                <p className={styles.p}>2.7 发布内容、评论、私信。vivo社区提供社交互动功能，为了您可以在社区发布您的心得、建议和产品反馈，我们会收集您发布的信息、图片、视频与机型，并展示您的昵称、头像、机型与发布内容。该信息由您主动填写，且会上传至服务器。</p>
                <p className={styles.p}>当您在社区跟其他用户私信聊天时，我们会收集您的社区头像、昵称、图片、视频、文字，用于正常创建聊天并保存曾创建的历史聊天对话框。该信息由您主动填写，且会上传至服务器。</p>

                <p className={styles.p}>2.8 浏览内容。当您浏览vivo社区中您所感兴趣的内容或服务时，我们会收集您的cookie内容，用于为您提供基础信息流功能。该信息仅在本地处理，不上传至服务器。</p>

                <p className={styles.p}>2.9 系统升级尝鲜。当您申请系统升级尝鲜服务时，我们会收集您的系统版本号、硬件型号以为您提供相应版本的内测安装包。该信息仅在本地处理，不上传至服务器。</p>

                <p className={styles.p}>2.10 新品内测、体验。当您申请对我们的新品进行内测或体验时，我们会收集您的地址信息，以便在您被选中时为您邮寄新品。该信息为您主动填写，并上传至服务器。</p>

                <p className={styles.p}>2.11 用户体验改进计划。我们希望为您提供更好的服务及用户体验，当您同意本协议后，我们可能基于提升用户体验的目的使用您的vivo账号openid信息。通过对此信息的处理，我们可以了解您是如何使用本服务，以持续不断地提升产品的操作体验，使我们的产品和服务更加符合您的需求并及时解决故障问题，从而为您带来良好的用户体验，并提高我们的总体服务品质和用户体验。</p>

                <p className={styles.p}>2.12 线下打卡活动。当您通过线下打卡活动进入打卡页面时，我们会使用您的地理位置，以判断您是否在指定地点附近打卡范围、能否成功参与打卡，此时我们会收集并使用您的地理位置信息，该信息为您主动提供并上传至我们的服务器。</p>

                <p className={styles.p}>2.13 NFC快捷登录。当您通过NFC快捷登录vivo社区时，我们需要您授权手机的NFC权限。NFC读取的相关信息仅在您的设备本地处理，不会上传到我们服务器。</p>

                <p className={styles.p}>2.14 以下情形中，我们可能会收集、使用您的相关个人信息而无需征求您的授权同意：</p>
                <ul className={styles.ul}>
                    <li className={styles.li}>（1）与国家安全、国防安全有关的；</li>
                    <li className={styles.li}>（2）与公共安全、公共卫生、重大公共利益有关的；</li>
                    <li className={styles.li}>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</li>
                    <li className={styles.li}>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
                    <li className={styles.li}>（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</li>
                    <li className={styles.li}>（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
                    <li className={styles.li}>（7）根据您的要求签订合同所必需的；</li>
                    <li className={styles.li}>（8）为合法的新闻报道所必需的；</li>
                    <li className={styles.li}>（9）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</li>
                    <li className={styles.li}>（10）与我们履行法律法规规定的义务相关的；</li>
                    <li className={styles.li}>（11）用于维护我们产品和/或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</li>
                    <li className={styles.li}>（12）法律法规规定的其他情形。</li>
                </ul>

                <h2 className={styles.h2}>三、我们如何共享您的个人信息</h2>

                <p className={styles.p}>3.1 vivo社区不会对外公开或向任何非关联第三方提供前述收集的您的信息，除非：</p>
                <ul className={styles.ul}>
                    <li className={styles.li}>（1）事先获得您的明确授权。获取您的明确同意后，我们会向您指定的第三方共享您授权范围内的信息。</li>
                    <li className={styles.li}>（2）为您提供所要求的产品和服务所必需。当您选择了我们与业务合作伙伴共同提供的服务时，为保障服务的顺利完成，我们会基于合法、正当、必要的原则向业务合作伙伴共享您的个人信息。合作伙伴可能会有各类技术服务商、内容提供方、广告分析服务类供应商等。</li>
                    <li className={styles.li}>（3）根据相关法律法规或法院、政府主管部门的要求，依据相关法律法规，我们需要协助配合提供您的个人信息。</li>
                    <li className={styles.li}>（4）为维护vivo或您的合法权益。</li>
                </ul>

                <p className={styles.p}>3.2 为了更好的向您提供账号注册服务，保护用户隐私，vivo有可能需要将合法收集的您在注册或使用账号服务时主动提交的信息（如您的手机号码以及账号注册时间等），经过加密或采取其他安全措施后，将所收集的部分信息交由第三方供应商分析与处理，vivo将严格要求第三方供应商保护您的信息，并在限定范围内使用您的信息，该第三方供应商如运营商移动、电信或联通等，可能的使用目的如识别注册手机号码是否为运营商二次重放号码，便于您顺利完成账号注册服务，保护用户隐私安全。</p>

                <p className={styles.p}>3.3 我们集成的三方sdk。当您在本产品中使用三方服务时，涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。我们也会通过协议或其他技术方式，约束或监督三方在授权范围内处理您的个人信息并保障您的信息安全。</p>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>第三方公司名称</th>
                            <th>产品/类型</th>
                            <th>共享信息名称</th>
                            <th>使用目的</th>
                            <th>使用场景</th>
                            <th>共享方式</th>
                            <th>第三方个人信息处理规则</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>深圳市腾讯计算机系统有限公司</td>
                            <td>微信分享SDK</td>
                            <td>内容信息（分享或收藏内容详情）</td>
                            <td>帮助用户分享内容至微信或添加微信收藏</td>
                            <td>在调起微信进行分享或收藏内容时使用</td>
                            <td>SDK本机采集</td>
                            <td>
                                <a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8" target="_blank" rel="noopener noreferrer" className={styles.a}>
                                    https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>深圳市腾讯计算机系统有限公司</td>
                            <td>Bugly SDK</td>
                            <td>手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID</td>
                            <td>排查质量问题,帮助APP提升运行质量</td>
                            <td>排查质量问题,帮助APP提升运行质量</td>
                            <td>SDK本机采集</td>
                            <td>
                                <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56" target="_blank" rel="noopener noreferrer" className={styles.a}>
                                    https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h2 className={styles.h2}>四、我们如何处理未成年人的个人信息</h2>
                <p className={styles.p}>我们特别注意保护未成年人的隐私（未成年人年龄按您所在国法律以及各国家和地区的文化惯例确定），并敦请家长/监护人主动参与关注未成年人的活动和兴趣爱好。我们不以未成年人为目标，不会刻意收集未成年人的资料。如果家长/监护人发现未成年人的个人资料在未事先获得监护人同意的情况下被收集，请联系我们进行删除，并保证未成年人取消订阅或使用相关的服务。</p>
                <p className={styles.p}>对于未成年人中的儿童信息，除上述情形需要监护人积极行使相关权利，与我们共同保护儿童个人信息外，我们还会按照《儿童隐私保护声明》保护儿童个人信息。</p>

                <h2 className={styles.h2}>五、我们如何保存您的个人信息</h2>

                <p>5.1 保存期限。除非法律法规另有规定，我们将在实现本政策所述目的的最短必要期限内保留您的个人信息。当您的个人信息超出我们所保存的期限后，我们会对您的个人信息进行删除或匿名化处理。</p>

                <p>5.2 存放地域.我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。</p>

                <h2 className={styles.h2}>六、个人信息管理</h2>

                <p>6.1 查询、更正、访问。您有权访问您的个人信息，法律法规规定的例外情况除外。您可以登录vivo账号的设备上通过点击"我的"→"个人信息"来自行查询、访问、更正您的账号相关信息。您也可以在vivo社区-我的-设置-个人资料查询、更正、访问您社区的头像、昵称、性别等相关信息。</p>

                <p>6.2 注销。如您需要注销登录本产品使用的vivo账号，您需要登录后通过点击如下具体路径：【设置→账号中心→安全中心→隐私设置→账号注销】再根据相关提示进行操作。您注销上述账户的行为是不可逆行为，并且我们将停止为您提供vivo账号服务，不再收集您的个人信息，并依据您的要求删除与您账户相关的个人信息或作匿名化处理，但法律法规或监管机构对用户信息存储时间另有规定的除外。您也可以通过下述本政策写明的联系方式及链接内容，了解查询、修改、及删除等数据主体权利的实现方式。权利行使范围仅限于我们收集的您的信息范围。</p>

                <h2 className={styles.h2}>七、本政策如何更新</h2>
                <p className={styles.p}>请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且需要收集您的信息，我们会通过页面提示、交互流程、网站公告、另行签署协议等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。</p>

                <h2 className={styles.h2}>八、如何联系我们</h2>
                <p className={styles.p}>8.1 如果您有任何疑问、意见或建议，请通过vivo社区在线客服的方式与我们联系，我们将在验证您的信息主体身份后15个工作日内回复或法律法规要求的时限内作出合理的解释与答复。</p>
                <p className={styles.p}>8.2 更多有关数据安全以及权利行使方式等内容，请认真阅读《vivo隐私政策》（详见：<a href="https://www.vivo.com/cn/about-vivo/privacy-policy" target="_blank" rel="noopener noreferrer" className={styles.a}>https://www.vivo.com/cn/about-vivo/privacy-policy</a>），关于vivo账号相关使用情形，请您阅读《vivo账号隐私政策》：<a href="https://usrsys-pro.vivo.com.cn/pro/privacy/policy/privacy_zh_CN.html" target="_blank" rel="noopener noreferrer" className={styles.a}>https://usrsys-pro.vivo.com.cn/pro/privacy/policy/privacy_zh_CN.html</a>。</p>
                <p className={styles.p}>8.3 如果您对我们的答复或处理方式不满意，您可以将通过以下外部途径寻求解决方式：将投诉移交给东莞市第二人民法院（院本部总机：0769-89889888）进行司法管辖，或通过行业自律协会、政府相关管理机构等寻求帮助。</p>

                <h2 className={styles.h2}>九、保留说明</h2>
                <p className={styles.p}>虽然本隐私政策说明了我们在维护隐私资料方面所遵循的标准，我们将严格遵循此标准，采取一切合理可行的措施尽力保护您个人信息和数据的安全。但请您知悉并理解，<strong>我们无法控制所有因素或第三方如何收集、使用您的信息和数据，任何措施也无法完全做到无懈可击，我们无法向您保证您的数据与信息在任何情况下都不会被泄露。</strong>另外，在您使用第三方服务过程中，第三方服务可能根据其功能需求收集、使用您的信息和数据，请您在使用第三方应用时认真阅读其隐私政策，并谨慎提交个人信息与数据。<span className={styles.bold}>我们对任何第三方自行收集、使用您的信息和数据不做任何承诺，也不承担任何非我们原因造成您信息和数据泄露的责任。</span></p>

                <p className={styles.p}><strong>重要提示：鉴于当地法律和语言差异，当地语言版本的《隐私政策》可能与本版本有所不同。如果出现任何差异，请以简体中文版本为准。如您使用我们的服务，就表示您同意我们的隐私政策。</strong></p>

                <div className={styles.bottom}>
                    <p className={styles.p}>广东天宸网络科技有限公司</p>
                    <p className={styles.p}>注册地址：广东省东莞市长安镇长安兴发南路86号203室</p>
                </div>
            </div>
        );
    }
}

export default withRouter(PrivacyPCPage);
